import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.linkedin.com/in/avinash-s-naidu-0950351bb/" className="home__social-icon" target='_blank' rel="noopener noreferrer">
            <i className="uil uil-linkedin"></i>
        </a>

        <a href="https://github.com/AviN27" className="home__social-icon" target='_blank' rel="noopener noreferrer">
            <i className="uil uil-github"></i>
        </a>

        <a href="https://guthib.com/" className="home__social-icon" target='_blank' rel="noopener noreferrer">
            <i className="uil uil-instagram"></i>
        </a>
    </div>
  )
}

export default Social